import React from "react";
import "./style.css";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
export function TechsViewItems() {
  return (
    <div className="e_box p_wrapbox screen screen_3 ">
      <div
        data-animeff="linear"
        data-duration="1"
        className="e_box-000 p_fboxChild ping ping_3"
      >
        <div id="techs_item_yjxy" className="reset_style" originaled="true">
          <div>
            <p className="tech_txt">应急响应</p>
          </div>
        </div>
        <div id="techs_item_hyjc" className="reset_style" originaled="true">
          <div>
            <p className="tech_txt">海洋监测</p>
          </div>
        </div>
        <div
          id="techs_item_four"
          className="w_img-002"
          data-animation="once"
          originaled="true"
          animated="true"
        >
          <div className="w_img animated">
            <div className="e_box-000">
              <Link to={`/techs#tech4`}>
                <div className="e_image  p_dimage">
                  <img
                    src="img/jishu04.png"
                    alt=""
                    title=""
                    width="100%"
                    height="100%"
                  />
                </div>
              </Link>
            </div>
          </div>
        </div>
        <div
          id="techs_item_five"
          className="w_img-002"
          data-animation="once"
          originaled="true"
          animated="true"
        >
          <div className="w_img animated  ">
            <div className="e_box-000">
              <Link to={`/techs#tech5`}>
                <div className="e_image  p_dimage">
                  <img
                    src="img/p3.png"
                    alt=""
                    title=""
                    width="100%"
                    height="100%"
                  />
                </div>
              </Link>
            </div>
          </div>
        </div>
        <div id="techs_item_cjjc" className="reset_style" originaled="true">
          <div>
            <p className="tech_txt">沉降监测</p>
          </div>
        </div>
        <div id="techs_item_szct" className="reset_style" originaled="true">
          <div>
            <p className="tech_txt">数字测图</p>
          </div>
        </div>
        <div id="techs_item_nyyy" className="reset_style" originaled="true">
          <div>
            <p className="tech_txt">农业应用</p>
          </div>
        </div>
        <div
          id="techs_item_six"
          className="w_img-002"
          data-animation="once"
          originaled="true"
          animated="true"
        >
          <div className="w_img animated  ">
            <div className="e_box-000">
              <Link to={`/techs#tech6`}>
                <div className="e_image  p_dimage">
                  <img
                    src="img/p4.png"
                    alt=""
                    title=""
                    width="100%"
                    height="100%"
                  />
                </div>
              </Link>
            </div>
          </div>
        </div>
        <div id="techs_item_tdly" className="reset_style" originaled="true">
          <div>
            <p className="tech_txt">土地利用</p>
          </div>
        </div>
        <div
          id="techs_item_three"
          className="w_img-002"
          data-animation="once"
          originaled="true"
          animated="true"
        >
          <div className="w_img animated  ">
            <div className="e_box-000">
              <Link to={`/techs#tech3`}>
                <div className="e_image  p_dimage">
                  <img
                    src="img/jishu03.png"
                    alt=""
                    title=""
                    width="100%"
                    height="100%"
                  />
                </div>
              </Link>
            </div>
          </div>
        </div>
        <div
          id="techs_item_two"
          className="w_img-002"
          data-animation="once"
          originaled="true"
          animated="true"
        >
          <div className="w_img animated  ">
            <div className="e_box-000">
              <Link to={`/techs#tech2`}>
                <div className="e_image  p_dimage">
                  <img
                    src="img/jishu02.png"
                    alt=""
                    title=""
                    width="100%"
                    height="100%"
                  />
                </div>
              </Link>
            </div>
          </div>
        </div>
        <div
          id="techs_item_one"
          className="w_img-002"
          data-animation="once"
          originaled="true"
          animated="true"
        >
          <div className="w_img animated  ">
            <div className="e_box-000">
              <Link to={`/techs#tech1`}>
                <div className="e_image  p_dimage">
                  <img
                    src="img/jishu01_03.png"
                    alt=""
                    title=""
                    width="100%"
                    height="100%"
                  />
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
